import React from 'react'

import { Bold } from '@gousto-internal/citrus-react'
import classnames from 'classnames'

import css from './OrderConfirmationHeader.css'

type Props = {
  canEditOrder: boolean
  deliveryDate: string
  deliveryStart: string
  deliveryEnd: string
  whenCutoffTime: string
  whenCutoffDate: string
  isTransactional?: boolean
}

const OrderConfirmationHeader = ({
  canEditOrder,
  deliveryDate,
  deliveryStart,
  deliveryEnd,
  whenCutoffTime,
  whenCutoffDate,
  isTransactional,
}: Props) => (
  <div data-testing="orderConfirmationHeader">
    {isTransactional ? (
      <>
        <p className={css.paragraph}>This won&apos;t start or change your subscription.</p>
        <p data-testid="delivery-date-message" className={css.paragraph}>
          Delivery scheduled for{' '}
          <Bold>
            {deliveryDate}, {deliveryStart}-{deliveryEnd}
          </Bold>
          . Edit your choices by{' '}
          <Bold>
            {whenCutoffTime} {whenCutoffDate}
          </Bold>
          .
        </p>
      </>
    ) : (
      <>
        <p className={css.paragraph}>
          Delivery date: {deliveryDate}
          {', '}between {deliveryStart} and {deliveryEnd}
        </p>
        <p className={classnames(css.paragraph, css.bold)}>
          {canEditOrder
            ? `You can edit your choices until ${whenCutoffTime} on ${whenCutoffDate}`
            : `You can no longer edit your choices as editing closed at ${whenCutoffTime} on ${whenCutoffDate}`}
        </p>
      </>
    )}
  </div>
)

export { OrderConfirmationHeader }
